import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  chakMarkWhite,
  deleteIconBlue,
  deleteIconCircleOrange,
  eyeClose,
  gallery1,
  gallery10,
  gallery11,
  gallery12,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  menuDotsIcon,
  modalCloseIcon,
  moveIocn,
  pinIocn,
  RestoreIcon,
} from "../../../../../images";
import Modal from "react-bootstrap/Modal";
// import "./workPlacePopup.scss";
import { useWindowSize } from "react-use";
// import WorkPlaceDelete from "./WorkPlaceDelete";
import BottomSheetOptions from "../GalleryEditPopups/BottomSheetOptions";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import config from "../../../../../config/config";
import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
import BlurGalleryImage from "../../../../../components/BlurGalleryImage/BlurGalleryImage";
import useTheme from "../../../../../components/useTheme/useTheme";
// import BottomSheetOptions from "./BottomSheetOptions";

const SliderGalleryMobilePopup = forwardRef((props, ref) => {
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const [columns, setColumns] = useState(4); // Default: 4 columns
  const [checkedItems, setCheckedItems] = useState({});
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showGallerypopupDeleteVariant, setShowGallerypopupDeleteVariant] =
    useState(false);
  const { data: businessData, update: updateBusinessContext } =
    useBusinessContext();
  const galleryTitles = [
    { key: "project_renders_media", title: "Project Photos & Renders" },
    { key: "completed_products_media", title: "Products | Materials" },
    { key: "sites_inprogress_media", title: "Sites In Progress" },
    { key: "others_media", title: "Others" },
  ];
  const [arrangedImages, setArrangedImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const aws_object_url = config.aws_object_url;
  const baseUrl = config.api_url;
  const handleImageSelect = (item) => {
    // setSelectedImage(item);
    setSelectedImage((prevSelected) =>
      prevSelected?.id === item.id ? null : item,
    );
  };

  const handleReplaceImage = () => {
    if (selectedImage && props.onImageReplace) {
      props.onImageReplace(selectedImage);
      // handleClose();
    }
  };

  const handleClose = () => {
    setSelectedImage(null);
    props.handleClose();
  };

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 1024) setColumns(4);
      else if (window.innerWidth > 768) setColumns(4);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(2);
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  // Masonry logic: Arranging images row-wise instead of column-wise
  const createMasonryLayout = () => {
    const allImages = [];
    const categoryImages = {};

    galleryTitles.forEach((category) => {
      const categoryData = props?.data[category.key] || [];

      const visibleImages = categoryData.filter((image) => {
        // return true
        return image.visibility === true && image.softDelete === false;
      });

      categoryImages[category.key] = visibleImages;
      allImages.push(...visibleImages);
    });

    const images = allImages || [];
    let arranged = Array.from({ length: columns }, () => []);
    let columnHeights = Array(columns).fill(0);

    images?.forEach((img) => {
      const shortestColumnIndex = columnHeights.indexOf(
        Math.min(...columnHeights),
      );
      arranged[shortestColumnIndex].push({
        src: `${aws_object_url}business/${img?.url}`,
        id: img?._id,
        name: img?.name || img?.url,
        url: img?.url,
        category: img?.category,
        originalData: img,
      });
      columnHeights[shortestColumnIndex] += 1;
    });

    if (arranged.every((col) => col.length === 0)) {
      setArrangedImages([]);
    } else {
      setArrangedImages(arranged);
    }

    return arranged;
  };

  const [isHovered, setIsHovered] = useState(false);
  const menuRef = useRef(null);
  const handleShowDeletePopupClose = () => setShowDeletePopup(false);
  const handleShowDeletePopupOpen = () => setShowDeletePopup(true);
  const handleGallerypopupDeleteVariantOpen = () =>
    setShowGallerypopupDeleteVariant(true);
  const handleGallerypopupDeleteVariantClose = () =>
    setShowGallerypopupDeleteVariant(false);
  const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
  const handleOptionsPopupClose = () => setShowOptionsPopup(false);

  useImperativeHandle(ref, () => ({
    resetSelection: () => {
      setSelectedImage(null);
    },
  }));

  useEffect(() => {
    createMasonryLayout();
  }, [businessData, props?.data, columns]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {width <= 768 && (
        <BottomSheetOptions
          show={showOptionsPopup}
          handleClose={handleOptionsPopupClose}
          handelOpenDelete={() => {}}
          handelOpenRecentlyDeleted={() => {}}
          workplaceBottomSheet={true}
        />
      )}
      <Modal
        {...props}
        show={props.show}
        centered
        className={`Gallery_popup_modal gallery_popup_edit  ${
          theme === "dark" && "nw_gl_popup--dark-mode"
        }`}
        backdropClassName="custom-backdrop-gallery-edit"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button className="custom-cancel-btn" onClick={handleClose}>
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2 className="Gallery_popup_heading d-flex align-items-center">
            Gallery Images
            <div
              className="menu-wrapper"
              ref={menuRef}
              onClick={
                width <= 768
                  ? handleOptionsPopupOpen
                  : () => setIsHovered(!isHovered)
              }
            ></div>
          </h2>

          {arrangedImages?.length === 0 ? (
            <h3 className="popup_muted_title fst-italic">
              All the images are been shown on the homepage
            </h3>
          ) : (
            <h3 className="popup_muted_title fst-italic">
              Choose an image to replace the current one.
            </h3>
          )}

          <div className="masonry-gallery-two">
            {arrangedImages.map((column, colIndex) => (
              <div className="masonry-column" key={colIndex}>
                {column.map((item, index) => {
                  const itemKey = `${colIndex}-${index}`;
                  const isSelected = selectedImage?.id === item.id;
                  const isCurrentImage = props.currentImage?.url === item.url;

                  return (
                    <div
                      className="masonry-item position-relative"
                      key={itemKey}
                    >
                      {" "}
                      {/* <div
                        className="img-skeleton-bg"
                        style={{
                          aspectRatio: "auto",
                        }}
                      >
                        <img
                          src={item?.src}
                          alt={`Gallery ${index}`}
                          loading="lazy"
                          decoding="async"
                          onLoad={(e) => {
                            // Set parent height based on loaded image
                            const imgHeight = e.target.offsetHeight;
                            e.target.parentElement.style.minHeight = `${imgHeight}px`;
                          }}
                        />
                      </div> */}
                      <BlurGalleryImage
                        item={{
                          src: item.src,
                          width: item.originalData?.width,
                          height: item.originalData?.height,
                          blurHash: item.originalData?.blurHash,
                          visibility: item.originalData?.visibility,
                        }}
                        activeGallerImages={isSelected}
                        onClick={() => handleImageSelect(item)}
                      />
                      <div
                        onClick={(e) => {
                          handleImageSelect(item);
                        }}
                        className={`${
                          isSelected
                            ? "checked check_box_ctm_popup_wraper"
                            : "check_box_ctm_popup_wraper"
                        }`}
                      >
                        <input
                          // type="radio"
                          type="checkbox"
                          name="imageSelection"
                          checked={isSelected || false}
                          onChange={() => {}}
                          className="hiden_ip_ctm_popup"
                        />

                        {isSelected && (
                          <img
                            src={chakMarkWhite}
                            alt="Selected"
                            className="chek_mark_ctm_popup"
                          />
                        )}
                      </div>
                      {/* {!isCurrentImage && (
                      )} */}
                      {/* {isCurrentImage && (
                        <div className="current-image-overlay">
                          <span>Current</span>
                        </div>
                      )} */}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          {/* Add this after the masonry-gallery-two div closes */}
          {selectedImage && (
            <div className="delete_gallery_image d-flex">
              <div className="delete_wrapper me-0" onClick={handleReplaceImage}>
                {/* <img
                  src={deleteIconBlue}
                  alt="delete"
                  className="delete_icon"
                /> */}
                Replace Image
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
});

export default SliderGalleryMobilePopup;

// import React, {
//   forwardRef,
//   useEffect,
//   useImperativeHandle,
//   useRef,
//   useState,
// } from "react";
// import {
//   chakMarkWhite,
//   deleteIconBlue,
//   deleteIconCircleOrange,
//   eyeClose,
//   gallery1,
//   gallery10,
//   gallery11,
//   gallery12,
//   gallery2,
//   gallery3,
//   gallery4,
//   gallery5,
//   gallery6,
//   gallery7,
//   gallery8,
//   gallery9,
//   menuDotsIcon,
//   modalCloseIcon,
//   moveIocn,
//   pinIocn,
//   RestoreIcon,
// } from "../../../../../images";
// import Modal from "react-bootstrap/Modal";
// import { useWindowSize } from "react-use";
// import BottomSheetOptions from "../GalleryEditPopups/BottomSheetOptions";
// import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
// import config from "../../../../../config/config";

// const SliderGalleryMobilePopup = forwardRef((props, ref) => {
//   const { width } = useWindowSize();
//   const [columns, setColumns] = useState(4);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [showOptionsPopup, setShowOptionsPopup] = useState(false);
//   const { data: businessData, update: updateBusinessContext } =
//     useBusinessContext();

//   const galleryTitles = [
//     { key: "project_renders_media", title: "Project Photos & Renders" },
//     { key: "completed_products_media", title: "Products | Materials" },
//     { key: "sites_inprogress_media", title: "Sites In Progress" },
//   ];

//   const [arrangedImages, setArrangedImages] = useState([]);
//   const aws_object_url = config.aws_object_url;

//   const handleImageSelect = (item) => {
//     setSelectedImage(item);
//   };

//   const handleReplaceImage = () => {
//     if (selectedImage && props.onImageReplace) {
//       props.onImageReplace(selectedImage);
//       handleClose();
//     }
//   };

//   const handleClose = () => {
//     setSelectedImage(null);
//     props.handleClose();
//   };

//   useEffect(() => {
//     const updateColumns = () => {
//       if (window.innerWidth > 1200) setColumns(4);
//       else if (window.innerWidth > 1024) setColumns(4);
//       else if (window.innerWidth > 768) setColumns(4);
//       else if (window.innerWidth > 340) setColumns(2);
//       else setColumns(2);
//     };

//     updateColumns();
//     window.addEventListener("resize", updateColumns);
//     return () => window.removeEventListener("resize", updateColumns);
//   }, []);

//   // Create masonry layout for image selection
//   const createMasonryLayout = () => {
//     const allImages = [];
//     const categoryImages = {};

//     galleryTitles.forEach((category) => {
//       const categoryData = props?.data[category.key] || [];
//       const visibleImages = categoryData.filter(
//         (image) => image.visibility === true && !image.softDelete
//       );
//       categoryImages[category.key] = visibleImages;
//       allImages.push(...visibleImages);
//     });

//     const images = allImages || [];
//     let arranged = Array.from({ length: columns }, () => []);
//     let columnHeights = Array(columns).fill(0);

//     images?.forEach((img) => {
//       const shortestColumnIndex = columnHeights.indexOf(
//         Math.min(...columnHeights)
//       );
//       arranged[shortestColumnIndex].push({
//         src: `${aws_object_url}business/${img?.url}`,
//         id: img?._id,
//         name: img?.name || img?.url,
//         url: img?.url,
//         category: img?.category,
//         originalData: img,
//       });
//       columnHeights[shortestColumnIndex] += 1;
//     });

//     setArrangedImages(arranged);
//     return arranged;
//   };

//   const [isHovered, setIsHovered] = useState(false);
//   const menuRef = useRef(null);

//   const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
//   const handleOptionsPopupClose = () => setShowOptionsPopup(false);

//   useImperativeHandle(ref, () => ({
//     resetSelection: () => {
//       setSelectedImage(null);
//     },
//   }));

//   useEffect(() => {
//     createMasonryLayout();
//   }, [businessData, props?.data, columns]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsHovered(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <>
//       {width <= 768 && (
//         <BottomSheetOptions
//           show={showOptionsPopup}
//           handleClose={handleOptionsPopupClose}
//           handelOpenDelete={() => {}}
//           handelOpenRecentlyDeleted={() => {}}
//           workplaceBottomSheet={true}
//         />
//       )}

//       <Modal
//         {...props}
//         show={props.show}
//         centered
//         className="Gallery_popup_modal gallery_popup_edit"
//         backdropClassName="custom-backdrop-gallery-edit"
//         fullscreen={true}
//       >
//         <Modal.Header>
//           <button className="custom-cancel-btn" onClick={handleClose}>
//             <img
//               src={modalCloseIcon}
//               alt="close-icon"
//               className="ctm_img_bussine_edit_about"
//             />
//           </button>
//         </Modal.Header>
//         <Modal.Body>
//           <h2 className="Gallery_popup_heading d-flex align-items-center">
//             Replace Gallery Image
//             <div
//               className="menu-wrapper"
//               ref={menuRef}
//               onClick={
//                 width <= 768
//                   ? handleOptionsPopupOpen
//                   : () => setIsHovered(!isHovered)
//               }
//             ></div>
//           </h2>

//           <h3 className="popup_muted_title fst-italic">
//             {props.currentImage
//               ? `Choose an image to replace the current image at position ${
//                   props.position + 1
//                 }.`
//               : "Choose an image for this position."}
//           </h3>

//           {/* Show current image being replaced */}

//           <div className="masonry-gallery-two">
//             {arrangedImages.map((column, colIndex) => (
//               <div className="masonry-column" key={colIndex}>
//                 {column.map((item, index) => {
//                   const itemKey = `${colIndex}-${index}`;
//                   const isSelected = selectedImage?.id === item.id;
//                   const isCurrentImage = props.currentImage?.url === item.url;

//                   return (
//                     <div
//                       className={`masonry-item position-relative`}
//                       key={itemKey}
//                       style={
//                         isCurrentImage
//                           ? {
//                               opacity: 0.5,
//                               border: "2px solid #ccc",
//                               pointerEvents: "none",
//                             }
//                           : {}
//                       }
//                     >
//                       <img
//                         src={item?.src}
//                         alt={`Gallery ${index}`}
//                         loading="lazy"
//                       />

//                       {!isCurrentImage && (
//                         <div
//                           onClick={() => handleImageSelect(item)}
//                           className={`${
//                             isSelected
//                               ? "checked check_box_ctm_popup_wraper"
//                               : "check_box_ctm_popup_wraper"
//                           }`}
//                         >
//                           <input
//                             type="radio"
//                             name="imageSelection"
//                             checked={isSelected || false}
//                             onChange={() => {}}
//                             className="hiden_ip_ctm_popup"
//                           />

//                           {isSelected && (
//                             <img
//                               src={chakMarkWhite}
//                               alt="Selected"
//                               className="chek_mark_ctm_popup"
//                             />
//                           )}
//                         </div>
//                       )}

//                       {isCurrentImage && (
//                         <div className="current-image-overlay">
//                           <span>Current</span>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             ))}
//           </div>

//           {selectedImage && (
//             <div className="replace_gallery_image d-flex justify-content-center">
//               <div
//                 className="replace_wrapper"
//                 onClick={handleReplaceImage}
//                 style={{
//                   background: "#007bff",
//                   color: "white",
//                   padding: "12px 24px",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   fontWeight: "500",
//                 }}
//               >
//                 Replace Image
//               </div>
//             </div>
//           )}

//           {selectedImage && (
//             <div className="selected-image-preview mt-3">
//               <h4 className="selected-image-label">Selected Image:</h4>
//               <div className="selected-image-container">
//                 <img
//                   src={selectedImage.src}
//                   alt="Selected image"
//                   className="selected-image-preview-img"
//                   style={{
//                     width: "100px",
//                     height: "100px",
//                     objectFit: "cover",
//                     borderRadius: "8px",
//                     border: "2px solid #007bff",
//                   }}
//                 />
//               </div>
//             </div>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// });

// export default SliderGalleryMobilePopup;
